import { OrderObject } from '../types/objects';

/**
 * Ordena objetos pela prioridade de exportação
 * Critérios:
 * - pageIndex asc (undefined -> 0)
 * - exportIndex asc (null/undefined -> Infinity, ou seja, ao final)
 * - nome asc (fallback determinístico)
 */
export function sortByExportIndex(objects: OrderObject[], opts?: { nulls?: 'first' | 'last' }): OrderObject[] {
  const nullsPos = opts?.nulls === 'first' ? -1 : 1; // default 'last'
  return [...objects].sort((a, b) => {
    const pa = Number(a.pageIndex || 0);
    const pb = Number(b.pageIndex || 0);
    if (pa !== pb) return pa - pb;
    const aNull = a.exportIndex == null;
    const bNull = b.exportIndex == null;
    if (aNull && bNull) {
      // ambos null → fallback por nome
    } else if (aNull) {
      return nullsPos; // a vai depois (last) ou antes (first)
    } else if (bNull) {
      return -nullsPos; // b vai depois (last) ou antes (first)
    } else {
      const ea = Number(a.exportIndex);
      const eb = Number(b.exportIndex);
      if (ea !== eb) return ea - eb;
    }
    const na = String(a.nome || '');
    const nb = String(b.nome || '');
    return na.localeCompare(nb);
  });
}


